import Header from './components/Header/Header';
import Container from './components/Container/Container';
import Home from './components/Home/Home';
import Footer from './components/Footer/Footer';
import { useState, useEffect, useRef } from 'react';

const App = () => {

  const scrollRefs = {
    sesja1: useRef(null),
    sesja2: useRef(null),
    sesja3: useRef(null),
    sesja4: useRef(null)
  };

  const scrollToSection = (sectionId) => {
    const sectionRef = scrollRefs[sectionId]?.current;

    if (sectionRef) {
      const elementPosition = sectionRef.getBoundingClientRect();
      const offset = elementPosition.top + elementPosition.height / 2 - window.innerHeight / 2;

      window.scrollBy({
        top: offset,
        behavior: 'smooth'
      });
    }
  };

  useEffect(() => {
    const handleTouchMove = (event) => {
      const touch = event.touches[0];
      const startX = touch.clientX;
      const startY = touch.clientY;
      const threshold = 5; // Minimalna odległość w pikselach, aby rozróżnić przesunięcie w osi poziomej i pionowej

      if (Math.abs(startX - touch.clientX) > threshold) {
        event.preventDefault();
      }
    };

    // Blokowanie przesuwania strony w osi poziomej
    document.addEventListener('touchmove', handleTouchMove, { passive: false });

    return () => {
      // Przywracanie domyślnego zachowania przesuwania strony
      document.removeEventListener('touchmove', handleTouchMove, { passive: false });
    };
  }, []);

  // language

  const [language, setLanguage] = useState("eng");

  return (
    <>
      <Header scrollToSection={scrollToSection} language={language} setLanguage={setLanguage}/>
      <Container>
        <Home scrollRefs={scrollRefs} scrollToSection={scrollToSection} language={language} />
      </Container>
      <Footer scrollToSection={scrollToSection} language={language} />
    </>
  );
};

export default App;